import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import {  FilteringState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, TableEditColumn, TableFixedColumns } from "@devexpress/dx-react-grid-material-ui";
import { QueryString, TIMER_FILTER } from "../utils/react_grid_utils";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import Files from "react-files";
import { downloadXlsx } from "../operator/Utils";

import { Alert, Input, InputAdornment, Grid as MIUGrid, Snackbar, Tooltip} from '@mui/material'

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CookieService from "../../services/CookieService";
import Divider from '@mui/material/Divider';
import TextField from "@material-ui/core/TextField";
import { Add, List } from "@material-ui/icons";
import { MenuItem, } from "@material-ui/core";
import { ContentCopy } from "@mui/icons-material";
import Header from "../Header";



let user = CookieService.get("user");
const emailAdmin = process.env.REACT_APP_EMAIL_ADMIN;

const scales_d2i_api_resource = '/scales/d2i'
const scales_api_resource = '/scales'
const permission_name = 'Setores'

const SetoresPreferenciasTable = () => {
  const alert = useAlert();
  const [rows, setRows] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionD2I, setSelectedOptionD2I] = useState(null);
  const [filters, setFilters] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "id", width: '5%' },
  ]);
  const defaultColumns = [
    // { name: "id", title: "ID" },
    {}
  ];
  const [dynamicColumns, setDynamicColumns] = useState(defaultColumns)

  const [scalesD2I, setScalesD2I] = useState([]);
  const [scales, setScales] = useState([]);
  const [userAccess, setUserAccess] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [id, setId] = useState(0)
  const [fields, setFields] = useState(';');
  const [rawValue, setRawValue] = useState('')
  const defaultJsonData = {"Preferências":[]}
  const [jsonData, setjsonData] = useState(defaultJsonData);
  const defaultPromptAI = "Você é um assistente de gerenciamento de escalas e precisar alocar os anestesistas em seus devidos setores..."
  const [promptAI, setPromptAI] = useState('')
  const defaultPromptFix = `Se respeitado as informações acima e ainda não tenhamos o setor, valide o historico anexado e analíse a quantidade de vezes que ele ficou no setor para aquele dia da semana (segunda a domingo) e o periodo informado. 
    -Caso o anestesista não tenha o dia da semana e o período informado no histórico, considere apenas o setor mais comum que ele ja teve.

Com essas instruções, se no dia {DIA} no período da {PERIODO} tivessemos os seguintes anestesistas para escala, quais seriam os setores? 
Retornar somente um json com a resposta com 'Anestesista', 'Data' e 'Setor'

Considere tambem o MAXIMO de alocações por setores que precisa ser preenchido, e caso algum anestesista não tenha nenhum setor, aloque em algum remanescente (pode ser que sobre setores):
{QTD SETORES}

Anestesistas da escala de hoje:

{JSON ANESTESISTAS}`
  const [promptFix, setPromptFix] = useState(defaultPromptFix)

  // - modal create
  const [openCreate, setOpenCreate] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [openView, setOpenView] = useState(false)

  // - modal import
  const [openImport, setOpenImport] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleUpdateValue = (updated_value) => {
    setRawValue(getJSONOutput())
  }

  function getAllScalesD2I(){
    return http.get(scales_d2i_api_resource);
  }

  function getAllScales(){
    return http.get(scales_api_resource);
  }

  const Update = () => {
    const data = {
      id: id,
      prompt_ai: promptAI,
      fields: fields,
      json_data: jsonData,
    }
    return new Promise((resolve, reject) => {
      http.put(scales_api_resource, data).then(
        (response) => {
          alert.success(`Preferência  para "${selectedOption?.name} (${selectedOption?.name})" atualizada com sucesso`);
          resolve(response);
          setSelectedOption(undefined)
          getAllScales()
          .then((response) => {
            setScales(response.data);
          })
          .catch((error) => {
            console.error("Error fetching scales:", error);
          });
        },
        (error) => {
          alert.show("Erro ao atualizar preferência", { type: "error" });
          reject(error);
        }
      );
    });
  };

  const Create = () => {
    const data = {
      scale_id: selectedOptionD2I.id,
      prompt_ai: promptAI,
      fields: fields,
      json_data: jsonData,
    }
    return new Promise((resolve, reject) => {
      http.post(scales_api_resource, data).then(
        (response) => {
          alert.success(`Preferência para "${selectedOptionD2I?.name} (${selectedOptionD2I?.unit})" criada com sucesso`);
          resolve(response);
          handleCloseCreate()
          getAllScales()
          .then((response) => {
            setScales(response.data);
          })
          .catch((error) => {
            console.error("Error fetching scales:", error);
          });
        },
        (error) => {
          alert.show("Erro ao criar preferência", {type: error});
          reject(error);
        }
      )
    })
  };

  const Delete = () => {
    return new Promise((resolve, reject) => {
      http.delete(scales_api_resource+`/${id}`).then(
        (response) => {
          alert.success(`Preferências para "${selectedOption?.name} (${selectedOption?.unit})" deletadas com sucesso`);
          resolve(response);
          handleCloseDelete()
          setSelectedOption(undefined)
          getAllScales()
          .then((response) => {
            setScales(response.data);
          })
          .catch((error) => {
            console.error("Error fetching scales:", error);
          });
        },
        (error) => {
          alert.show("Erro ao criar preferência", {type: error});
          reject(error);
        }
      )
    })
  };

  function getSetoresEscalaDados(escala_setores_id) {
    console.log('get getSetoresEscalaDados', escala_setores_id)
    const queryString = QueryString(0, 0, filters);
    console.log(`${scales_api_resource}/${escala_setores_id}${queryString}`)
    http.get(`${scales_api_resource}/${escala_setores_id}${queryString}`).then(
      (response) => {
        //const filteredRows = response.data.filter(row => row.enable);
        console.log('response', response)
        setjsonData(response.data.json_data)   
        setRows(
          response.data.json_data["Preferências"].map((item) => ({
            ...item, // Mantém os dados existentes
            id: response.data.id, // Adiciona o ID ao objeto
          }))
        );        
      },
      (error) => {
        console.log('getSetoresEscalaDados error', error);
      }
    );
  }

  const handleOpenCreate = () => {
    setSelectedOption(undefined)
    setFields('Anestesista;Setor')
    setjsonData(defaultJsonData)
    setId(0)
    setPromptAI(defaultPromptAI)
    setSelectedOptionD2I(null)
    setOpenCreate(true);
  };

  const handleCloseCreate = () => {
    setSelectedOption(undefined)
    setSelectedOptionD2I(null)
    setOpenCreate(false);
  };

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOpenView = () => {
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
  };
  //
  const handleSelectionChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    let selectedRow
    if(selectedId){
      selectedRow = scales.find((scale) => String(scale.id) === String(selectedId));
      setSelectedOption(selectedRow);
    }else{
      setRows([])
      setSelectedOption(undefined)
    }
  };

  const handleSelectionChangeD2I = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    let selectedRow
    console.log('selectedIdD2I', selectedId)
    if(selectedId){
      selectedRow = scalesD2I.find((scale) => String(scale.id) === String(selectedId));
    }else{
      selectedRow = {id: -1, name: ''}
    }

    console.log('selectedRow', selectedRow)
    setSelectedOptionD2I(selectedRow);
  };

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFilters(filters);

    setTimer(
      setTimeout(() => {
        if (selectedOption) {
          getSetoresEscalaDados(selectedOption.id);
        }
      }, TIMER_FILTER)
    );
  }

  const TableRowComponent = ({ row, ...restProps }) => (
    <TableRow
      {...restProps}
    />
  );

  const CellWithTooltip = ({ value, ...restProps }) => {
    let displayValue = value;

    if (typeof value === 'object' && value !== null) {
      // Se o valor for um objeto, tenta extrair texto ou converter para string
      displayValue = value.richText ?? JSON.stringify(value);
    }

    return (
      <Tooltip title={value || "N/A"} arrow>
        <TableCell {...restProps}>{displayValue}</TableCell>
      </Tooltip>
    )  
  };

  const capitalizeFirstLetter = (str) => {
    return str
      .replace(/_/g, ' ') // Substitui "_" por espaço
      .split(' ')          // Divide a string em palavras
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitaliza cada palavra
      .join(' ');          // Junta as palavras de volta com espaços
  };

  const updateField = (group, index, key, value, type='') => {
    const updatedJsonData = { ...jsonData };
    const jsonGroup = updatedJsonData[group]
    if (Array.isArray(jsonGroup)){
      updatedJsonData[group][index][key] = value;
    }else{
      if (type === 'key'){
        // ADD BOTAO PARA DEL E ADD
        const old_value = updatedJsonData[group][key]
        delete updatedJsonData[group][key]; // Remove a chave antiga
        updatedJsonData[group][value] = old_value; // Atualiza o objeto na posição 'index'
      }
      else{
        updatedJsonData[group][key] = value;
      }
        
    }
    setjsonData(updatedJsonData); // Atualiza o estado com os novos valores  
    setRawValue(getJSONOutput())
  };
  
  const handleCopy = (content) => {
    navigator.clipboard.writeText(content).then(() => {
      setSnackbarOpen(true)
    }).catch(() => {
      alert.error('Falha ao copiar o texto.');
    });
  };

  const renderJsonFields = (jsonGroup, group, fields) => {
    // Verifica se jsonGroup é um array
    if (Array.isArray(jsonGroup)) {
      return jsonGroup.map((item, index) => (
        <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          {fields.map((field) => (
            <TextField
              key={field}
              variant="outlined"
              disabled={!userCanEdit()}
              fullWidth
              label={capitalizeFirstLetter(field)}
              value={item[field] || ''} // Acesse o valor do campo se existir
              name={field}
              onChange={(e) => updateField(group, index, field, e.target.value)} // Atualiza o campo específico
            />
          ))}
          <Tooltip title="Remover Item">
            <Button 
              disabled={!userCanEdit()}
              variant="text" 
              onClick={() => removeItem(group, index)}>
                <i className="fa fa-trash btn btn-danger" aria-hidden="true"></i>
              {/* <Delete /> */}
            </Button>
          </Tooltip>
        </div>
      ));
    } else {
      return <div>Não há dados disponíveis ou o formato dos dados é inválido.</div>;
    }
  };

  const renderJsonKeyValue = (key, jsonValues) => {
    // Verifica se jsonValues é um objeto válido
    try {
      return Object.entries(jsonValues).map(([keyy, value], index) => (
        <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          {/* Campo para chave */}
          <TextField
            variant="outlined"
            disabled={!userCanEdit()}
            fullWidth
            label="Chave"
            value={keyy || ''} // Usa keyy como valor
            name={`key_${keyy}`} // Nome do campo como 'key_keyy'
            onChange={(e) => updateField(key, index, keyy, e.target.value, 'key')} // Update o campo da chave
          />
          
          {/* Campo para valor */}
          <TextField
            variant="outlined"
            disabled={!userCanEdit()}
            fullWidth
            label="Valor"
            value={value || ''} // Usa value como valor
            name={`value_${keyy}`} // Nome do campo como 'value_keyy'
            onChange={(e) => updateField(key, index, keyy, e.target.value, 'value')} // Update o campo do valor
          />
        </div>
      ));
    } catch (error) {
      return <div>Não há dados disponíveis ou o formato dos dados é inválido.</div>;
    }
  };
   
  const renderJsonData = () => {
    return Object.keys(jsonData).map((key) => {
      const jsonGroup = jsonData[key];  // A chave aqui é o nome do grupo, como 'group1', 'group2'
      
      // Verifica se jsonGroup é um array
      if (Array.isArray(jsonGroup)) {
        return (
          <div key={key} style={{ marginBottom: '20px' }}>
            <div className="row" style={{marginBottom: '20px'}}>
              <h3
                style={{
                  color: '#3f51b5',
                  marginRight: '8px',
                  marginBottom: '8px',
                  marginLeft: '14px',
                  fontWeight: 800,
                }}
              >
                <List style={{ marginBottom: 4 }} /> {key}  {/* Aqui, 'key' é o nome do grupo */}
              </h3>
              <Tooltip title="Adicionar Item">
                <Button 
                  disabled={!userCanEdit()}
                  style={{ padding: 0 }}  
                  onClick={() => addItem(key)}>
                    <i className="fa fa-plus btn btn-primary"  color="green" aria-hidden="true"></i>
                  {/* <Add style={{ marginBottom: 8 }} /> */}
                </Button>
              </Tooltip>
              <Tooltip title="Limpar Tudo">
                <Button 
                  disabled={jsonData["Preferências"].length <= 0 || !userCanEdit()}
                  style={{ padding: 0 }}
                  onClick={() => setjsonData(defaultJsonData)}>
                    <i className="fa fa-ban btn btn-danger"  color="green" aria-hidden="true"></i>
                    
                  {/* <Add style={{ marginBottom: 8 }} /> */}
                </Button>
              </Tooltip>
              
            </div>
            {renderJsonFields(jsonGroup, key, fields.split(';'))}  {/* Passa o array para renderizar */}           
          </div>
        );
      } else if (typeof jsonGroup === 'object' && jsonGroup !== null) {
        return (
          <div key={key} style={{ marginBottom: '20px' }}>
            <div className="row">
              <h3
                style={{
                  color: '#3f51b5',
                  marginRight: '8px',
                  marginBottom: '8px',
                  marginLeft: '14px',
                  fontWeight: 800,
                }}
              >
                <List style={{ marginBottom: 4 }} /> {key}  {/* Aqui, 'key' é o nome do grupo */}
              </h3>
              <Tooltip title="Adicionar Item">
                <Button 
                  disabled={!userCanEdit()}
                  style={{ padding: 0 }} 
                  onClick={() => addItem(key)}>
                  <Add style={{ marginBottom: 8 }} />
                </Button>
              </Tooltip>
            </div>
            {renderJsonKeyValue(key, jsonGroup)}  {/* Passa o array para renderizar */}           
          </div>
        )  
      }
      else {
        console.log('jsonGroup', jsonGroup)
        return <div key={key}>Dados inválidos para o grupo {key}</div>;
      }
    });
  };
  
  // Função para remover um contato de um grupo
  const removeItem = (group, index) => {
    const newData = { ...jsonData};
    newData[group].splice(index, 1);
    setjsonData(newData);
    console.log('newData', newData) 
    handleUpdateValue('')
  };

  // Função para adicionar um novo contato a um grupo
  const addItem = (group) => {
    const newData = { ...jsonData };
    newData[group] = newData[group] || [];
    newData[group].push(
      fields.split(';').reduce((acc, option) => ({ ...acc, [option]: '' }), {})
    );
    //newData[group].push({ name: '', mail: '', telephone: '' });
    setjsonData(newData); 
    handleUpdateValue('')
  };

  const getJSONOutput = () => JSON.stringify(jsonData);

  const userCanView = () => {
    if (user?.email === emailAdmin)
      return true
    const access = userAccess.find(access => access.name === permission_name && access.checked);
    return access ? access.checked : false;
  }

  const userCanEdit = () => {
    if (user?.email === emailAdmin)
      return true
    const access = userAccess.find(access => access.name === permission_name && access.checked  && access.allow_edit);
    return access ? access.allow_edit : false;
  };
 
  useEffect(() => {
    //Set User
    if (user && user.user_access) {
      setUserAccess(user.user_access);
    }
  }, []); //[user]);

  useEffect(() => {
    getAllScalesD2I()
      .then((response) => {
        setScalesD2I(response.data);
      })
      .catch((error) => {
        console.error("Error fetching scales D2I:", error);
      });
  }, []);

  useEffect(() => {
    getAllScales()
      .then((response) => {
        setScales(response.data);
      })
      .catch((error) => {
        console.error("Error fetching scales:", error);
      });
  }, []);

  useEffect(() => {
    if (scales.length === 0) return; // Evita execução desnecessária
    // Remove da lista scalesD2I os itens que já existem em scales
    const filteredScalesD2I = prevScalesD2I => prevScalesD2I.filter(scaleD2I => !scales.some(scale => String(scale.scale_id) === String(scaleD2I.id)))
    setScalesD2I(filteredScalesD2I);
  }, [scales])

  useEffect(() => {
    const columns = fields
      ?.split(";") // Divide a string em um array
      .map((field) => ({
        name: field, // Nome da coluna baseado no campo
        title: field, // Remove espaços extras e define o título
        getCellValue: (row) => {
          return row?.[field] ?? "";
        },
      })) || [];
    // setDynamicColumns([...defaultColumns, ...columns])
    setDynamicColumns([...columns])
  }, [openView])

  useEffect(() => {
    if (selectedOption) {
      getSetoresEscalaDados(selectedOption.id);
    } else {
      setRows([]);
    }
  }, [selectedOption, filters]);

  //Start Values
  useEffect(() => {
    if (selectedOption){
      setjsonData(selectedOption?.json_data ?? '')
      setRawValue(JSON.stringify(selectedOption?.json_data ?? ''))
      setPromptAI(selectedOption?.prompt_ai)
      setFields(selectedOption?.fields)
      setId(selectedOption?.id)
      console.log('selectedOption', selectedOption)  
    }
    const columns = selectedOption?.fields
      ?.split(";") // Divide a string em um array
      .map((field) => ({
        name: field, // Nome da coluna baseado no campo
        title: field, // Remove espaços extras e define o título
        getCellValue: (row) => {
          return row?.[field] ?? "";
        },
      })) || [];
    // setDynamicColumns([...defaultColumns, ...columns])
    setDynamicColumns([...columns])
  }, [selectedOption])

  useEffect(() => {
    console.log("useEffect", jsonData)
    if (jsonData) {
      setRows(
        jsonData["Preferências"].map((item) => ({
        ...item,
        id:selectedOption?.id,
        }))
      );
    }
  }, [jsonData])

  useEffect(() => {
    if (openView) {
      document.querySelector('.navbar-static-side').style.zIndex = '1000';
    } else {
      document.querySelector('.navbar-static-side').style.zIndex = '2001';
    }
  }, [openView]);
  

  function onFilesError(error, file) {
    console.log("error code " + error.code + ": " + error.message);
  }

  function onFilesChange(files) {
    var file = files[0];
    setFile(file);
    setFileName(file?.name);
  }

  function handleCloseImport() {
    setOpenImport(false);
  }

  function handleOpenImport() {
    setOpenImport(true);
  }

  function importar() {
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append("upload", new Blob([file], { type: file.type }), file.name || "file");
  
        var url = scales_api_resource + "/import" + `?id=${id}`;
  
        http.post(url, formData).then(
          (response) => {
            setOpenImport(false);
            alert.success(`Preferência para "${selectedOption?.name} (${selectedOption?.name})" atualizada com sucesso`);
            setSelectedOption(undefined)
            getAllScales()
            .then((response) => {
              setScales(response.data);
            })
            .catch((error) => {
              console.error("Error fetching scales:", error);
            });
          },
          (error) => {
            if (error?.messages) {
              error.messages.map((erro_msg) => {
                alert.error("Erro. " + erro_msg?.error?.message, { timeout: 20000 });
              });
            } else {
              alert.error("Erro!");
            }
            setOpenImport(false);
          }
        ).finally(() => {
          setLoading(false); // Finaliza o estado de loading
        });
      } else {
        alert("Informe um arquivo para importação!");
      }
  }

  function exportar () {
    http.get(`${scales_api_resource}/export/${id}`, { responseType: "blob" }).then(
      (response) => {
        downloadXlsx(response.data);
      },
      (error) => {
        console.log(error);
        alert.error("Falha ao gerar arquivo para exportação")
      }
    );
  };
  
  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-8">
            <h2><i className="fa fa-cogs"></i> Preferências Setores</h2>
          </div>
          <div className="col-lg-4" style={{ textAlign: "right", alignSelf: "flex-end" }}>
            <button 
              type="button"
              style={{marginRight: '5px'}}
              className="btn btn-success"
              onClick={() => handleOpenImport()}
              disabled={!selectedOption || !userCanEdit()}
            >
              Importar  <i class="fa fa-download" aria-hidden="true"></i>
            </button>
            <button 
              type="button"
              style={{marginRight: '5px'}}
              className="btn btn-success"
              onClick={() => handleOpenView()}
              disabled={!selectedOption}
            >
              Visualizar  <i className="fa fa-eye"></i>
            </button>
            <button 
              type="button"
              style={{marginRight: '5px'}}
              className="btn btn-primary"
              onClick={() => handleOpenCreate(true)}
              disabled={!userCanEdit()}
            >
              Criar  <i className="fa fa-plus"></i>
            </button>
          </div>
          <div className="col-lg-12 mt-4">
            <TextField
              select
              label="Escala"
              variant="outlined"
              value={selectedOption?.id || null} 
              onChange={handleSelectionChange}
              fullWidth
            >
              <MenuItem value="">Selecione...</MenuItem>
              {scales?.map((scale) => {
                return (
                  <MenuItem key={scale.id} value={scale.id}>
                    {scale.name} ({scale.unit})
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
            Texto copiado para a área de transferência!
          </Alert>
        </Snackbar>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">

                  {/* ESCALA SETORES */}
                  {!selectedOption && (<div><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Selecione uma escala</div>)}
                  {selectedOption && userCanView() ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ color: '#3f51b5', marginRight: '8px', marginBottom:'8px', marginTop: '8px', fontWeight: 600, fontSize: 18 }}>Preferência de setores para escala {selectedOption?.name} ({selectedOption?.unit})</span>
                    <Tooltip title="Deletar">
                    <Button 
                      disabled={!userCanEdit()}
                      variant="text" 
                      onClick={() => handleOpenDelete()}>
                        <i className="fa fa-trash btn btn-danger" aria-hidden="true"></i>
                    </Button>
                    </Tooltip>
                    
                    <Divider style={{ flex: 1 }} />
                  </div>
                  ): <></>}

                  {selectedOption && userCanView() ? (
                    <MIUGrid container justifyContent="space-between">
                      
                      <MIUGrid item xs={12} md={12} mt={2}>
                        <TextField
                          variant='outlined'
                          multiline
                          fullWidth        
                          label="Prompt IA"
                          onChange={(e) => setPromptAI(e.target.value)}
                          value={promptAI}
                          disabled={!userCanEdit()}
                          minRows={6}
                          maxRows={12}
                          name="prompt_ai"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                        />
                      </MIUGrid>
                      <MIUGrid item xs={12} md={12} mt={2}>
                        <TextField
                          variant='outlined'
                          multiline
                          disabled={true}
                          fullWidth        
                          label="Prompt Fixo"
                          value={promptFix}
                          minRows={6}
                          maxRows={12}
                          name="prompt_fix"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                        />
                      </MIUGrid>
                      <MIUGrid item xs={12} md={12} mt={2}>
                        <TextField
                          variant='outlined'
                          fullWidth        
                          label="Campos de Preferências (separados por ponto e vírgula)"
                          value={fields}
                          disabled={!userCanEdit()}
                          onChange={(e) => setFields(e.target.value)}
                          name="fields"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                        />
                      </MIUGrid>
                    </MIUGrid>
                  ) : (<></>)}
                  {selectedOption && userCanView() ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ color: '#3f51b5', marginRight: '8px', marginBottom:'8px', marginTop: '8px', fontWeight: 600, fontSize: 18 }}>Tabela de Preferências</span>
                    <Divider style={{ flex: 1 }} />
                  </div>
                  ): (<></>)}
                  
                  {/* ESCALA SETORES DADOS*/}
                  {selectedOption && userCanView() ? (renderJsonData()) : <></>}  
                  
                  {selectedOption && userCanView() ? (
                    <MIUGrid item xs={12} md={12} mt={2}>
                      <TextField
                        variant='outlined'
                        disabled= {true}
                        fullWidth  
                        label="Raw"
                        value={rawValue}
                        name="raw"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={() => handleCopy(rawValue)} edge="end">
                                <ContentCopy/>
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />  
                    </MIUGrid>):<></>}
                  
                  {/* BOTÃO SALVAR ALTERAÇÔES */}
                  {selectedOption && userCanEdit() ? (
                    <div className="col-lg-12" style={{ textAlign: "right", alignSelf: "flex-end", marginTop: 12, padding: 0 }}>
                      <Button 
                        style={{marginRight: 0, marginBottom: 12, marginTop: 12}}
                        disabled={!userCanEdit() || id === 0}
                        variant="contained"
                        color="primary"
                        onClick={() => Update()} 
                      >
                        {'Salvar alterações'}&nbsp; <i className="fa fa-save"></i>
                      </Button> 
                    </div>
                     
                  ) :<></>}
                  
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    
    {/* View */}
    <Dialog
      open={openView} 
      onClose={handleCloseView} 
      maxWidth="lg"
      fullWidth
      container={document.body}
      sx={{
        zIndex: '3001 !important', // Força o z-index acima do menu
      }}
      PaperProps={{
        style: {
          zIndex: '3001 !important', 
          width: '90%', 
          margin: '0 auto',
          height: '80vh', // Altura fixa para permitir rolagem
          // display: 'flex',
          // flexDirection: 'column',
        },
      }}>
      <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
        <span style={{ display: 'inline-block', width: '100%' }}>
          Preferências {selectedOption?.name}
        </span>
        <button 
          className="btn btn-success btn-sm"
          disabled={rows.length <= 0}
          style={{
            position: 'absolute',
            right: 70,
            top: 18

          }}
          type="button" 
          onClick={() => exportar()}
        >
         <i class="fa fa-upload" aria-hidden="true"></i>  Exportar
        </button>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleCloseView}
          aria-label="close"
          style={{
            position: 'absolute',
            right: 30,
            top: 20,
            padding: 0
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent 
      style={{
        flex: 1,
      }}>
        <div style={{
        minWidth: `${Math.max(dynamicColumns.length * 150, 800)}px`, // Ajusta dinamicamente
      }}>
          <Grid rows={rows} columns={dynamicColumns}>
            <FilteringState filters={filters} onFiltersChange={handleFilters} />
            <Table columnExtensions={tableColumnExtensions} rowComponent={TableRowComponent} cellComponent={CellWithTooltip}/>
            <TableHeaderRow />
            <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
    
    {/* Create */}
    <Dialog 
      open={openCreate} 
      onClose={handleCloseCreate} 
      maxWidth="md"
      fullWidth
      PaperProps={{
          style: {
            width: '800px', 
            margin: '0 auto'
          },
      }}
    >
    <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
      <span style={{ display: 'inline-block', width: '100%' }}>
        Criar nova preferência de setor
      </span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={handleCloseCreate}
        aria-label="close"
        style={{
          position: 'absolute',
          right: 30,
          top: 20,
          padding: 0
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <Divider variant="fullWidth" />
    <DialogContent >
      <DialogContentText style={{ color: "black" }}>
        <MIUGrid container justifyContent="space-between">
          <MIUGrid item xs={12} md={12} mt={2}>
            <TextField
              select
              label="Escala"
              variant="outlined"
              value={selectedOptionD2I?.id}
              onChange={handleSelectionChangeD2I}
              fullWidth
            >
              <MenuItem value="">Selecione...</MenuItem>
              {scalesD2I?.map((scale) => {
                return (
                  <MenuItem key={scale.id} value={scale.id}>
                    {scale.name} ({scale.unit})
                  </MenuItem>
                );
              })}
            </TextField>

            {/* <select 
              style={{marginBottom: 16}} 
              onChange={handleSelectionChangeD2I}>
              <option value="">Selecione uma Escala</option>
              {scalesD2I.map((scale) => (
                <option key={scale.id} value={scale.id}>
                  {scale.name} ({scale.unit})
                </option>
              ))}
            </select> */}
          </MIUGrid>
          <MIUGrid container justifyContent="space-between">
            <MIUGrid item xs={12} md={12} mt={2}>
              <TextField
                variant='outlined'
                disabled={!userCanEdit()}
                fullWidth        
                label="Campos de Dados"
                value={fields}
                onChange={(e) => setFields(e.target.value)}
                name="fields"
                InputLabelProps={{
                  shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                }}
              />
            </MIUGrid>
            <MIUGrid item xs={12} md={12} mt={2}>
              <TextField
                variant='outlined'
                multiline
                disabled={!userCanEdit()}
                fullWidth        
                label="Prompt IA"
                value={promptAI}
                onChange={(e) => setPromptAI(e.target.value)}
                minRows={6}
                name="prompt_ai"
                InputLabelProps={{
                  shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                }}
              />
            </MIUGrid>
          </MIUGrid>
        </MIUGrid>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      
      <Button onClick={handleCloseCreate}  color="primary">
        Fechar
      </Button>
      <Button 
        style={{marginRight:16}} 
        onClick={ () => Create() } 
        variant="contained" 
        color="primary"
        disabled={(selectedOptionD2I?.name !== undefined && selectedOptionD2I?.name !== '') ? false : true}
      >
        Criar
      </Button>
    </DialogActions>
    </Dialog>
  
    
    {/* Delete */}
    <Dialog 
      open={openDelete} 
      onClose={handleCloseDelete} 
      maxWidth="md"
      fullWidth
      PaperProps={{
          style: {
            width: '800px', 
            margin: '0 auto'
          },
      }}
    >
    <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
      <span style={{ display: 'inline-block', width: '100%' }}>
        Apagar preferências de setor para {selectedOption?.name} ({selectedOption?.unit})[{id ?? 0}] 
      </span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={handleCloseDelete}
        aria-label="close"
        style={{
          position: 'absolute',
          right: 30,
          top: 20,
          padding: 0
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <Divider variant="fullWidth" />
    <DialogContent >
      <DialogContentText style={{ color: "black" }}>
        <MIUGrid container justifyContent="space-between">
          <MIUGrid item xs={12} md={12} mt={2}>
            Você está prestes a deletar as prefêrencias e essa ação não poderá ser desfeita. Continuar?
          </MIUGrid> 
        </MIUGrid>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      
      <Button onClick={handleCloseDelete}  color="primary">
        Cancelar
      </Button>
      <Button 
        style={{marginRight:16}} 
        onClick={ () => Delete() } 
        variant="contained" 
        color="secondary"
      >
        Deletar
      </Button>
    </DialogActions>
    </Dialog>


    {/* Import */}
    <Dialog 
      open={openImport} 
      onClose={handleCloseImport} 
      maxWidth="md"
      fullWidth
      PaperProps={{
          style: {
            width: '800px', 
            margin: '0 auto'
          },
      }}
    >
      <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
        <span style={{ display: 'inline-block', width: '100%' }} disabled={!userCanEdit()}>
          Importar Preferências {selectedOption?.name} ({selectedOption?.unit})
        </span>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleCloseImport}
          aria-label="close"
          style={{
            position: 'absolute',
            right: 30,
            top: 20,
            padding: 0
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      {loading ? (
        <div style={{ textAlign: "center", margin: "20px" }}>
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem" }}></i>
          <p>Processando...</p>
        </div>
      ) : (
        <form>
          <div className="form-group row">
            <div className="col-sm-12">
              <Files className="files-dropzone" onChange={onFilesChange} onError={onFilesError} accepts={[".xls", ".xlsx", ".csv"]} multiple={false} maxFileSize={10000000} minFileSize={0} clickable>
                <div className="input-group">
                  <div className="custom-file">
                    <input readOnly={true} type="text" className="form-control" value={fileName} style={{ width: "300px" }} />
                    <label className="custom-file-label" htmlFor="inputGroupFile01">
                      {fileName}
                    </label>
                  </div>
                </div>
              </Files>
            </div>
          </div>
          <div className="hr-line-dashed"></div>
          <div style={{ textAlign: "center", alignSelf: "center", display: "flex", marginBottom: 20 }}>
            <div className="col-sm-12 col-sm-offset-2">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Ao importar, todos os dados antigos serão excluídos e substituídos pela nova importação.
            </div>
          </div>
          <div className="form-group row" style={{ textAlign: "right" }}>
            <div className="col-sm-12 col-sm-offset-2">
              <button className="btn btn-danger" type="button" onClick={handleCloseImport} style={{ width: "70px" }}>
                Fechar
              </button>            
              <button className="btn btn-success" style={{ marginLeft: "10px", width: "150px" }} type="button" onClick={() => importar()}>
                Importar
              </button>
            </div>
          </div>
        </form>
      )}
      </DialogContent>
      
    </Dialog>

    </div>
  );
};

export default SetoresPreferenciasTable;
